
import { defineComponent, defineAsyncComponent } from 'vue';

export default defineComponent({
	props: {
		amount: {
			required: true,
			type: String,
		},
		icon: {
			required: true,
			type: String,
		},
		title: {
			required: true,
			type: String,
		},
	},
	setup(props) {
		const getComponent = () => {
			return defineAsyncComponent({
				loader: () =>
					import(`@/components/ui-elements/icons/${props.icon}.vue`),
			});
		};

		return { getComponent };
	},
});
